import { MejorateDraft } from "./MejorateCreate";
import { NotificacionCreateWithAuthor } from "./NotificacionCreate";

import { FormatDate } from "../components/documentacion/FormatDate";

export async function MejorateHelper({ datconsumoData, tratamientoId, pacienteId, onComplete }) {
  const todayDate = new Date().toISOString().split("T")[0];
  console.log(datconsumoData, tratamientoId, pacienteId);

  // Comprobación previa: solo continuar si el tipo es "ingreso"
  if (datconsumoData.meta?.datconsTipo?.toLowerCase() !== "ingreso") {
    console.log("El tipo de datos de consumo no es 'ingreso'. Finalizando.");
    if (onComplete) {
      onComplete(); // Llamada a la redirección o finalización
    }
    return; // Finaliza la función
  }

  // Obtener sustancias principales directamente
  const principalSustancias = datconsumoData.meta?.datconsSustRep?.filter(
    (sust) => sust.nivelimportancia === "principal"
  ) || [];
  console.log("Sustancias principales:", principalSustancias);

  // Clasificación por tipo de sustancia
  const alcoholGroup = principalSustancias.filter((sust) =>
    ["aguardiente", "alcohol", "anis", "cerveza", "champan", "conac", "ginebra", "licor", "ron", "tequila", "vermut", "vino", "vodka", "whisky"].includes(sust.sustancia)
  );
  console.log("Alcohol:", alcoholGroup);

  const cocainaGroup = principalSustancias.filter((sust) =>
    ["cocaina", "anfetaminas", "metanfetamina"].includes(sust.sustancia)
  );

  console.log("Cocaina:", cocainaGroup);

  const benzodiacepinasGroup = principalSustancias.filter((sust) =>
    ["benzodiacepina", "alprazolam", "diazepam", "lorazepam"].includes(sust.sustancia)
  );

  console.log("Benzodiacepinas:", benzodiacepinasGroup);

  const cannabisGroup = principalSustancias.filter((sust) => sust.sustancia === "cannabis");

  console.log("Cannabis:", cannabisGroup);

  try {
    // Crear cuestionarios según los grupos
    if (alcoholGroup.length > 0) {
      console.log("Alcohol");
      console.log(todayDate, tratamientoId, pacienteId, "Alcohol")
      await MejorateDraft(todayDate, tratamientoId, pacienteId, "Alcohol");
    }
    if (cocainaGroup.length > 0) {
      console.log("Cocaina");
      await MejorateDraft(todayDate, tratamientoId, pacienteId, "Cocaína");
    }
    if (benzodiacepinasGroup.length > 0) {
      console.log("Benzodiacepinas");
      await MejorateDraft(todayDate, tratamientoId, pacienteId, "Benzodiazepinas");
    }
    if (cannabisGroup.length > 0) {
      console.log("Cannabis");
      await MejorateDraft(todayDate, tratamientoId, pacienteId, "Cannabis");
    }

    if (cannabisGroup.length > 0 || alcoholGroup.length > 0 || cocainaGroup.length > 0 || benzodiacepinasGroup.length > 0) {
      // Crear notificación
      await NotificacionCreateWithAuthor(
        pacienteId,
        todayDate,
        `${FormatDate(todayDate)} - Tienes opciones de mejora esperándote`,
        `/perfil/${tratamientoId}/mejorate/`,
        false,
        pacienteId,
        true,
        true
      );
    }

    // Llamar la redirección al finalizar todo
    if (onComplete) {
      onComplete();
    }
  } catch (error) {
    console.error("Error al crear cuestionarios o notificación:", error);
  }
}
